import React, { useEffect, useState } from "react";
import InquiryDetail from "../components/InquiryDetail/InquiryDetail";
import { useSearchParams } from "react-router-dom";
import * as apis from "../apis";

export default function InquiryDetailContainer() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        const res = await apis.getContactOne(id);
        setData(res?.data?.data);
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message || "문의를 불러오는데 실패 하였습니다."
        );
      }
    };
    fetchData();
  }, [id]);

  return <InquiryDetail data={data} />;
}
